import { combineReducers } from 'redux';
import auth from './redux-store/auth/authReducers';
import documents from './redux-store/documentIdentification/documentIdentificationReducers';

export default combineReducers({
    auth,
    documents,
});
